import React, { useState, useEffect } from 'react'
import {
    Button,
    Spinner,
    Card,
    Select,
    Option,
} from "@material-tailwind/react";
import { ToastContainer, toast } from 'react-toastify';

import { useShared } from '../../hooks/useShared';
import ABreadcrumbs from '../breadcrumbs/ABreadcrumbs';
import ViewDialog from '../modals/ViewDialog';
import DeleteDialog from '../modals/DeleteDialog';
import AddNewDialog from '../modals/AddNewDialog';
import EmptyTable from '../table/EmptyTable';
import Pagination from '../table/Pagination';
import AdvanceSearch from '../table/AdvanceSearch';
import AIcon from '../partials/AIcon';
import AAlert from '../partials/AAlert';
import UploadFileDialog from '../modals/UploadFileDialog';
import ApproveDialog from '../modals/ApproveDialog';
import ArchiveFilesListModal from '../modals/ArchiveFilesListModal';
import CloseNotfication from '../modals/CloseNotfication';
import { CSVLink } from "react-csv";
import ExportReport from '../reports/ExportReport';
import ASelect from '../fields/ASelect';
import Skeleton from '../skeleton/Skeleton';



export default function MainSection({ v }) {

    const [loading, setLoading] = useState({ show: false, all: 0 })
    const [budgets, setBudgets] = useState([])
    const [inputFields, setInputFields] = useState([])
    const [searchFields, setSearchFields] = useState([])
    const [csvData, setCsvData] = useState([])
    const [generateExcel, setGenerateExcel] = useState(false)

    const { http, com, setPhoto, navigate,
        model, setModel,
        models, setModels,
        getOnce, setGetOnce, setGeneratePDF,
        showSearchBox, setShowSearchBox,
        showNewModelDialog, setShowNewModelDialog,
        showViewDialog, setShowViewDialog,
        openUploadFileDialog, setOpenUploadFileDialog,
        openApproveDialog, setOpenApproveDialog, setCountries,
        showFilesModal, auth, getNotifications,
        showDeleteDialog, setShowDeleteDialog } = useShared();


    useEffect(() => {
        if (v?.newModelInputFields) setInputFields([...v?.newModelInputFields])
        if (v?.searchInputFields) setSearchFields([...v?.searchInputFields])
    }, [])

    const getModels = async (page, data = null) => {
        // setModels([]);
        try {
            setLoading(pre => ({ ...pre, all: 1 }))

            data = convertDate(data, 'created_at')
            data = convertDate(data, 'shipping_date')
            data = convertDate(data, 'from_date')
            data = convertDate(data, 'to_date')

            const res = await http.post(`api/${v?.mUrl?.getAll}?page=${page}`, data);
            console.log('mainSection getModels ', res);
            if (res.data.success) {
                setGetOnce(true)
                setModels(res.data.data)

                if (v?.mUrl?.create === 'tariffs' || v?.mUrl?.create === 'invoices') {
                    getNotifications()
                }
            }
            setLoading(pre => ({ ...pre, all: 2 }))
        } catch (error) {
            console.log("error ", error, error?.response?.data?.message);
            toast.warning(error?.message)
            setLoading(pre => ({ ...pre, all: 2 }))
        }
    }



    useEffect(() => {
        if (!getOnce) {
            setTimeout(() => getModels(1, v?.searchData), 10)
        }
    }, [getOnce])



    const getUserRoles = (index) => {

        setLoading(pre => ({ ...pre, show: true }))
        http.post('api/rolesAdvanceSearch', { nameId: true }).then(res => {
            console.log("roleAdvanceSearch ", res);
            if (res.data.success) {
                setLoading(pre => ({ ...pre, show: false }))
                v.searchInputFields[index].options = res.data?.data
                setInputFields(v?.newModelInputFields)
                setShowSearchBox(true)
            }
        }, err => {
            setLoading(pre => ({ ...pre, show: false }))
            console.log('getUserRoles error ', err);
        })
    }

    const getZones = (index) =>{
        console.log("getZones");
        setLoading(pre => ({ ...pre, show: true }))
        http.post('api/zonesAdvanceSearch', { nameId: true }).then(res => {
            console.log("roleAdvanceSearch ", res);
            if (res.data.success) {
                setLoading(pre => ({ ...pre, show: false }))
                v.searchInputFields[index].options = res.data?.data
                setInputFields(v?.newModelInputFields)
                setShowSearchBox(true)
            }
        }, err => {
            setLoading(pre => ({ ...pre, show: false }))
            console.log('getZones error ', err);
        })
    }

    const getBudgets = (index, which) => {

        setLoading(pre => ({ ...pre, show: true }))
        http.post('api/budgetsAdvanceSearch', { nameId: true }).then(res => {
            console.log("budgetsAdvanceSearch ", res);
            if (res.data.success) {
                setLoading(pre => ({ ...pre, show: false }))
                setBudgets(res.data?.data)

                v.newModelInputFields[index].options = res.data?.data
                v.searchInputFields[index].options = res.data?.data
                setInputFields(v?.newModelInputFields)

                which === 'new' ? setShowNewModelDialog(true) : setShowSearchBox(true)
            }
        }, err => {
            setLoading(pre => ({ ...pre, show: false }))
            console.log('budgetsAdvanceSearch error ', err);
        })
    }

    const getCategories = (which, index, type) => {
        console.log("getCategories");
        setLoading(pre => ({ ...pre, show: true }))
        http.post('api/categoryAdvanceSearch', type).then(res => {
            console.log("categoryAdvanceSearch archive ", res);
            if (res.data.success) {
                setLoading(pre => ({ ...pre, show: false }))
                const data = res.data?.data;



                if (which === 'new') {
                    setShowNewModelDialog(true)
                    v.newModelInputFields[index].options = data
                    setInputFields(v?.newModelInputFields)
                }
                else {
                    v.searchInputFields[index].options = data
                    setSearchFields(v?.searchInputFields)
                    setShowSearchBox(true)
                }
            }
        }, err => {
            setLoading(pre => ({ ...pre, show: false }))
            console.log('categoryAdvanceSearch archive error ', err);
        })
    }

    const getUsers = (index, model = "tariffs") => {
        console.log('getUsers ', index);
        http.post('api/userAdvanceSearch', { model }).then(res => {
            if (res?.data?.success) {
                const data = res?.data?.data;
                v.searchInputFields[index].options = data
                setSearchFields(v?.searchInputFields)
                setShowSearchBox(true)
                setLoading(pre => ({ ...pre, show: false }))
            }
        }, err => {
            setLoading(pre => ({ ...pre, show: false }))
            console.log('getUserList error ', err);
        })

    }


    const getCompanies = (index) => {
        console.log("getCompanies");
        setLoading(pre => ({ ...pre, show: true }))
        http.post('api/companyAdvanceSearch', { companyByNameAF: true }).then(res => {
            console.log("companyAdvanceSearch getCompanies ", res);
            if (res.data.success) {
                setLoading(pre => ({ ...pre, show: false }))
                const data = res.data?.data;
                v.searchInputFields[index].options = data
                setSearchFields(v?.searchInputFields)
                setShowSearchBox(true)
            }
        }, err => {
            setLoading(pre => ({ ...pre, show: false }))
            console.log('companyAdvanceSearch getCompanies error ', err);
        })
    }


    const getCountries = (index) => {

        v.searchInputFields[index].options = setCountries()
        setSearchFields(v?.searchInputFields)
    }





    const convertDate = (data, value) => {
        if (data) {
            const date = Object.keys(data).find(key => key === value)
            if (date) { // convert shamsi date to miladi
                console.log("test date created", date);
                data[date] = com.dateConvert(data[date])
            }
        }
        return data
    }


    const addNew = () => {
        setGeneratePDF(false)
        if (v?.mUrl?.create === 'companies' && auth.hasRole([1, 2, 23])) {
            navigate("/db/companies/new_company/0", { state: { modelName: v?.modelName } })
            //  getUserList('new')
        } /* else if (categories?.length === 0 && v?.mUrl?.create === 'categories') {
            getParentCategories('new')
        } */
        else {
            if (v?.mUrl?.create === 'users' && auth.hasRole([1, 2, 21])) {
                navigate("/db/users/new_user/0", { state: v?.searchData })
            }
            else if (v?.mUrl?.create === 'employees' && auth.hasRole([1, 2, 22])) {
                navigate("/db/users/new_user/0", { state: v?.searchData })
            }
            else if (v?.mUrl?.create === 'invoices') {
                navigate("/db/invoices/0/new_invoice/0", { state: { modelName: v?.modelName, fields: v?.fields } })
            }

            else if (v?.mUrl?.create === 'archives') {
                navigate("/db/archives/new_archive/0", { state: { modelName: v?.modelName } })
            }

            else if (v?.mUrl?.create === 'tariffs') {
                navigate("/db/tariffs/0/new_tariff/0", { state: { modelName: v?.modelName } })
            }
            else if (v?.mUrl?.create === 'exdletters') {
                navigate("/db/export_duty_letters/0/new_letter/0", { state: { modelName: v?.modelName } })
            } else if (v?.mUrl?.create === 'categories' && auth.hasRole([1, 2, 25])) {
                getCategories("new", 2, { nameId: true })
            }
            else if (v?.mUrl?.create === 'expenses' && auth.hasRole([1, 2, 20])) {
                getBudgets(1, 'new')
                setShowNewModelDialog(true)
            }

            else if (v?.mUrl?.create === 'budgets' && auth.hasRole([1, 2, 20])) {
                setShowNewModelDialog(true)
            }
            else if (v?.mUrl?.create === 'zones' && auth.hasRole([1, 2, 24])) {
                setShowNewModelDialog(true)
            }
            else if (v?.mUrl?.create === 'roles' && auth.hasRole([1])) {
                setShowNewModelDialog(true)
            }
            /*
                        else {

                                setShowNewModelDialog(true)


                        } */

        }
        setModel({})
        setPhoto(null);
    }

    const handleSearch = () => {
        console.log("handleSearch ", v?.url, searchFields[3]?.options)


        if (searchFields[5]?.options?.length === 0 && v?.url === 'companies') {
            getUsers(4, v?.url) // get for owneer
            getUsers(5, 'user') // get for creator
            //  getUserList('search')
        }
        else if (searchFields[3]?.options?.length === 0 && (v?.url === 'users' || v?.url === 'employees')) {
            getUserRoles(3, 'search')
            getUsers(4, 'user')
        }

        else if (budgets?.length === 0 && v?.url === 'expenses') {
            getBudgets(1, 'search')
        }
        else if (searchFields[1]?.options?.length === 0 && (v?.url === 'archives' || v?.url === 'list_archives')) {
            getCategories("", 1, { typeId: 7 })
            getZones(2)
        }
        else if (searchFields[4]?.options?.length === 0 && (v?.mUrl?.create === 'tariffs')) {
            getUsers(4)
        }
        else if (searchFields[1]?.options?.length === 0 && (v?.url === 'invoices')) {
            getCompanies(1);
            getCountries(2)
            getUsers(5, v?.url)
        }
        else if (searchFields[2]?.options?.length === 0 && (v?.url === 'exdletters')) {
            getCompanies(2);
            getCountries(3)
        } else if (searchFields[1]?.options?.length === 0 && (v?.url === 'categories')) {
            getCategories("", 1, { nameId: true })
            getUsers(2)
        } else if (searchFields[1]?.options?.length === 0 && (v?.url === 'card_membership')) {
            getCategories("", 1, { typeId: 35 })
            getUsers(2)
        }
        else if (searchFields[0]?.options?.length === 0 && (v?.url === 'exports')) {
            getCompanies(0);
            getCountries(1)
            getUsers(4)
        } else
            setShowSearchBox((search) => !search)
    }


    const handleMenu = (model, flag = false) => {
        console.log("handleMenu ", model, flag, v?.mUrl?.create);

        if (flag === 'delete') {
            setModel(model)
            setShowDeleteDialog(!showDeleteDialog)
        }
        if (flag === 'edit') {
            setModel(model)
            if (v?.url === 'users' || v?.url === 'employees') {
                navigate(`/db/users/new_user/${model.id}`, { state: v?.searchData })
            }/*  else if (userList?.length === 0 && v?.mUrl?.create === 'companies') {
                //getUserList('new')
            } *//*  else if (categories?.length === 0 && v?.mUrl?.create === 'categories') {
                getParentCategories('new')
            } */

            else {
                setShowNewModelDialog(true)
            }

        }
        if (flag === 'view') {
            setModel(model)
            setShowViewDialog(true)
        }


    };

    const handleDelete = async () => {

        models.data = models?.data?.filter(item => item?.id !== model?.id);
        setModels(models);
        setShowDeleteDialog(!showDeleteDialog)
        try {
            const res = await http.remove(`/api/${v?.mUrl?.delete}/${v?.mUrl?.delete === "backups" ? model?.file_name : model.id}`);
            console.log("remove role ", res);
            if (res.data.success) {
                toast.success(res.data.message);
                getModels(1, v?.searchData);
            }
            //  mReset()
        } catch (error) {
            console.log("error ", error);
        }
    }



    const getCSV = () => {
        console.log("getCSV", models);
        setCsvData([])

        if (v?.mUrl?.create === 'companies') {
            models?.data?.map((m, i, { length }) => {

                setCsvData(pre => [...pre,
                {
                    index: (i + 1),
                    name_af: m?.name_af,
                    name_en: m?.name_en,
                    license_number: m?.license_number,
                    tin_number: m?.tin_number,
                    establishment_date: com.dateConvert(m?.establishment_date, false),
                    address: m?.address,
                    owner: m?.owner?.full_name,
                    date: com.dateConvert(m?.updated_at, false),
                    status: m?.status === 0 ? "Disabled" : m?.status === 1 ? "Enable" : "",
                    creator_id: m?.user?.full_name,
                }])
            })
        }
        else if (v?.mUrl?.create === 'users') {
            models?.data?.map((m, i, { length }) => {
                setCsvData(pre => [...pre,
                {
                    index: (i + 1),
                    full_name: m?.full_name,
                    father_name: m?.father_name,
                    phone: m?.phone,
                    email: m?.email,
                    roles: m?.roles?.map(it => `${it?.label}`).join(', '),
                    position: m?.position?.label,
                    salary: m?.salary,
                    home_address: m?.home_address,
                    date: com.dateConvert(m?.updated_at, false),
                    status: m?.status === 0 ? "Disable" : m?.status === 1 ? "Enable" : "",
                    creator_id: m?.user?.full_name,
                }])


            })
        }
        else if (v?.mUrl?.create === 'employees') {
            models?.data?.map((m, i, { length }) => {
                setCsvData(pre => [...pre,
                {
                    index: (i + 1),
                    full_name: m?.full_name,
                    father_name: m?.father_name,
                    phone: m?.phone,
                    email: m?.email,
                    roles: m?.roles?.map(it => `${it?.label}`).join(', '),
                    home_address: m?.home_address,
                    date: com.dateConvert(m?.updated_at, false),
                    status: m?.status === 0 ? "Disable" : m?.status === 1 ? "Enable" : "",
                    creator_id: m?.user?.full_name,
                }])


            })
        }

        else if (v?.mUrl?.create === 'tariffs') {
            models?.data?.map((m, i, { length }) => {
                if (i < length - 1)
                    setCsvData(pre => [...pre,
                    {
                        index: (i + 1),
                        company: m?.company?.name_af,
                        items: m?.items?.map(it => `${it?.category?.label}: ${com.NumberFormatter(it?.tariff_amount)}`).join(' - '),
                        date: com.dateConvert(m?.updated_at, false),
                        status: m?.status === 0 ? "Upload Aviza" : m?.status === 1 ? "Pending Approval" : "Completated",
                        creator_id: m?.user?.full_name,
                    }])

                else {
                    setCsvData(pre => [...pre,
                    {
                        index: (i + 1),
                        company: "Total",
                        items: com.NumberFormatter(m?.amount) + " افغانی ",

                    }])
                }
            })
        }

        else if (v?.mUrl?.create === 'invoices') {
            models?.data?.map((m, i, { length }) => {

                setCsvData(pre => [...pre,
                {
                    index: (i + 1),
                    invoice_number: m?.invoice_number,
                    from: m?.from?.name_af,
                    items: m?.tariff?.items?.map(it => `Name: ${it?.category?.label} \nQuantity: ${it?.quantity} \nPrice Per Unit: ${com.NumberFormatter(it?.price_per_unit)}`).join(' \n\n- '),
                    currency: m?.currency?.label,
                    ship_to: m?.shipping_state?.label,
                    shipping_date: com.dateConvert(m?.shipping_date, false),
                    date: com.dateConvert(m?.updated_at, false),
                    status: m?.status === 0 ? "Upload Aviza" : m?.status === 1 ? "Pending Approval" : "Completated",
                    creator_id: m?.user?.full_name,
                }])


            })
        }
        else if (v?.mUrl?.create === 'budgets') {
            models?.data?.map((m, i, { length }) => {

                setCsvData(pre => [...pre,
                {
                    index: (i + 1),
                    name: m?.name,
                    amount: com.NumberFormatter(m?.amount) + " افغانی ",
                    rest_amount: com.NumberFormatter(m?.rest_amount) + " افغانی ",
                    from_date: com.dateConvert(m?.from_date, false),
                    to_date: com.dateConvert(m?.to_date, false),
                    expenses: m?.expenses_count,
                    date: com.dateConvert(m?.updated_at, false),
                    status: m?.status === 0 ? "Upload Aviza" : m?.status === 1 ? "Pending Approval" : "Completated",
                    creator_id: m?.user?.full_name,
                }])
            })
        }

        else if (v?.mUrl?.create === 'expenses') {
            models?.data?.map((m, i, { length }) => {

                setCsvData(pre => [...pre,
                {
                    index: (i + 1),
                    name: m?.name,
                    amount: com.NumberFormatter(m?.amount) + " افغانی ",
                    budget_type: m?.budget_type?.label,
                    from_date: com.dateConvert(m?.from_date, false),
                    to_date: com.dateConvert(m?.to_date, false),
                    date: com.dateConvert(m?.updated_at, false),
                    status: m?.status === 0 ? "Upload Aviza" : m?.status === 1 ? "Pending Approval" : "Completated",
                    creator_id: m?.user?.full_name,
                }])
            })
        }

        else if (v?.mUrl?.create === 'zones') {
            models?.data?.map((m, i, { length }) => {

                setCsvData(pre => [...pre,
                {
                    index: (i + 1),
                    name: m?.name,
                    phone: m?.phone,
                    email: m?.email,
                    address: m?.address,
                    description: m?.description,
                    date: com.dateConvert(m?.updated_at, false),
                    creator_id: m?.user?.full_name,
                }])
            })
        }

    }

    const createBackup = (flag) => {
        console.log(flag);
        setLoading(pre => ({ ...pre, all: 1 }))

        http.post(`/api/backups`, { type: flag }).then(res => {
            console.log(res);
            if (res?.data?.success) {
                getModels(1, v?.searchData)
                setLoading(pre => ({ ...pre, all: 2 }))
                toast.success(res?.data?.message)

            }
        }, err => {
            setLoading(pre => ({ ...pre, all: 2 }))
            toast.warning("error ...")
            console.log(err);
        })
    }


    return (
        <div>
            <ABreadcrumbs links={v?.breadcrumbs} />

            <AAlert />
            <div className='md:flex flex-col items-start  max-h' dir={v?.url === 'backups' ? 'ltr' : ''}>

                <Card className="w-full  p-2 md:p-4 mt-4 ">
                    <div className='flex justify-between items-center'>
                        <legend className="text-sm text-main-color font-bold">{v?.tableTitle}</legend>
                        <div className='flex '>


                            {/* Excel Report */}
                            {v?.excel?.show && <Button variant='outlined' size='sm' className='py-0  m-1 flex items-center gap-1' color="purple" onClick={() => setGenerateExcel(pre => !pre)}>
                                <AIcon name="cloud-circle-outline" size="20" className="p-0" /><span className='hidden md:block'>  ايجاد گزارش </span>
                            </Button>}

                            {/* CSV Report */}
                            {v?.csv?.show && <Button variant='outlined' size='sm' className='p-0 m-1' color="purple" >
                                <CSVLink asyncOnClick={true} className='  p-2 rounded-md px-3 ' onClick={getCSV}
                                    data={csvData} headers={v?.csv?.csvHeaders}>
                                    <AIcon name="cloud-download-outline" size={20} className="mt-1" />
                                </CSVLink>
                            </Button>}


                            {/*  Backups generateing options */}
                            {v?.url === 'backups' && <div>
                                <Select label="Select Backup" onChange={createBackup}>
                                    <Option value='--only-db'>Only SQL DB</Option>
                                    <Option value='--only-files'>Only Project Files</Option>
                                    <Option value='0'>Whole Project</Option>
                                </Select>
                            </div>}


                            {/* New Model */}
                            {inputFields?.length > 0 &&
                                <Button variant='outlined' size='sm' className='flex items-center gap-1 py-1 px-2 text-main-color border-main-color m-1' onClick={addNew}>
                                    {!loading.show ? <AIcon name="add-circle-outline" size="20" className="p-0" /> : <Spinner className="h-4 w-4" />}<span className='hidden md:block'>{v?.addNewItemTitle}</span>
                                </Button>
                            }

                            {/* Search data */}
                            {v?.url !== 'backups' && <Button variant='outlined' size='sm' className='flex items-center gap-1 py-1 px-2 text-blue-900 border-blue-900 m-1' onClick={handleSearch}>
                                {!loading.show ? <AIcon name="search-outline" size="20" className="p-0" /> : <Spinner className="h-4 w-4" />}<span className='hidden md:block'> {showSearchBox ? 'بستن' : 'جستجو'}   </span>
                            </Button>}

                            {/* Refresh data */}
                            <Button variant='outlined' size='sm' className='flex items-center gap-1 py-1 px-2 text-blue-900 border-blue-900 m-1' onClick={() => getModels(1, v?.searchData)}>
                                {loading.all === 1 ? <Spinner className="h-4 w-4" /> : <AIcon name="refresh-outline" size="20" className="p-0" />}
                            </Button>
                        </div>

                    </div>

                    {showSearchBox && <AdvanceSearch v={{ submit: (data) => getModels(1, data), loading, setShowSearchBox, showSearchBox, maxHeight: 'max-h-42', searchInputFields: searchFields, url: v?.url }} />}

                    <div className={`overflow-auto grid grid-cols-1 content-between   md:min-h-[450px]`} >
                        {v?.tableData && <table className="gTable">
                            <thead className='whitespace-nowrap'>
                                <tr >
                                    {v?.TABLE_HEAD?.map((head, i) => (
                                        <th key={head} className={`${head === "Description" && 'w-[20%]'} px-2 amiriB text-white`}> {head}</th>
                                    ))}
                                </tr>
                            </thead>
                            {v?.tableData}
                        </table>
                        }



                        {v?.list} {/*  Arcive folder list */}
                        <EmptyTable value={{ loading: loading.all, length: models?.data?.length }} />
                        {models && models?.last_page > 1 && <Pagination value={{ getFun: getModels, data: models }} />}

                    </div>

                </Card>
            </div>
            {/*  </ACard> */}

            {showViewDialog && <ViewDialog v={{ showViewDialog, setShowViewDialog, obj: v?.handleViewDialog(model), setModel: setModel, title: 'Model Details', className: "h-[90%]" }} />}

            {showDeleteDialog && <DeleteDialog value={{ showDeleteDialog, handleMenu: () => handleMenu(model, 'delete'), action: handleDelete, title: 'Delete', desc: "آیا می خواهید رکورد را حذف کنید؟" }} />}

            {showNewModelDialog && <AddNewDialog v={{
                showNewModelDialog, setShowNewModelDialog,
                title: model?.id > 0 ? 'Update Record' : v?.addNewItemTitle,
                inputs: inputFields,
                model,
                setModel,
                models,
                setModels,
                mUrl: v?.mUrl,
                modelName: v?.modelName,
                modelScreen: v?.modelScreen,

                className: v?.newModelDialogClassName,
                refersh: () => getModels(1, v?.searchData)
            }} />}
            {openUploadFileDialog && <UploadFileDialog v={{ openUploadFileDialog, setOpenUploadFileDialog, modelID: model?.id, modelURL: v?.mUrl?.create, attachName: v?.attachName, refersh: () => getModels(1, v?.searchData) }} />}
            {openApproveDialog && <ApproveDialog v={{ openApproveDialog, setOpenApproveDialog, modelURL: v?.mUrl?.create, modelName: v?.attachName, refersh: () => getModels(1, v?.searchData) }} />}
            {showFilesModal && <ArchiveFilesListModal v={{ refersh: () => getModels(1, v?.searchData) }} />}
            {generateExcel && <ExportReport v={{ generateExcel, setGenerateExcel, exports: models?.data }} />}
            <CloseNotfication v={{ refersh: () => getModels(1, v?.searchData) }} />
            <ToastContainer />

        </div>
    )
}

